import request from '../../../../../helpers/request';
import { buildShutdownsUrl } from '../../utils/buildShutdownsUrl';

export const fetchShutdowns = async (filters) => {
  const url = buildShutdownsUrl(filters);

  return await request.get(
    url,
    null,
    'При загрузке отключений произошла ошибка'
  );
};
